import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useState } from 'react';
import Stepper from '@mui/material/Stepper/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import { ThemeProvider, styled } from '@mui/material';
import { Button, Typography, useTheme } from '@emburse/embark-core';
const HoverButton = styled(Button)({
    '&:hover': {
        backgroundColor: 'rgba(0, 151, 220, 0.04) !important'
    }
});
const CustomStepper = forwardRef(({ currentStep, getHorizontalSteps, isVertical, verticalSteps = [], style, useButtonLabel, useForwardNav }, ref) => {
    const steps = !isVertical ? getHorizontalSteps() : null;
    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(currentStep);
    const [verticalCompleted, setVerticalCompleted] = useState(verticalSteps.map(() => false));
    const forwardNavClickHandler = (index, valid) => {
        if (valid) {
            setVerticalCompleted((prevState) => ({ ...prevState, [index]: true }));
            setActiveStep(index + 1);
        }
    };
    useImperativeHandle(ref, () => ({
        continueForwardNavigation(index, valid) {
            forwardNavClickHandler(index, valid);
        },
        setAllVerticalsComplete() {
            setVerticalCompleted(verticalSteps.map(() => true));
        }
    }));
    const buttonLabelDisabled = (index) => {
        if (index === 0) {
            return false;
        }
        if (verticalCompleted[index - 1]) {
            return false;
        }
        return true;
    };
    return (_jsx(ThemeProvider, { theme: theme, children: _jsx(Stepper, { activeStep: activeStep, alternativeLabel: !isVertical, style: style, orientation: isVertical ? 'vertical' : 'horizontal', children: !isVertical
                ? steps.map((step, index) => {
                    const stepProps = { completed: false };
                    stepProps.completed = index < activeStep;
                    return (_jsx(Step, { ...stepProps, children: _jsx(StepLabel, {}) }, step));
                })
                : verticalSteps.map((step, index) => {
                    const expanded = index === activeStep;
                    return (_jsxs(Step, { completed: verticalCompleted[index], expanded: expanded, children: [_jsx(StepLabel, { children: useButtonLabel ? (_jsxs(HoverButton, { variant: "text", color: "secondary", onClick: () => setActiveStep(index), style: { textTransform: 'none' }, disabled: buttonLabelDisabled(index), children: [_jsx(Typography, { display: "inline", color: !buttonLabelDisabled(index) || expanded
                                                ? 'textPrimary'
                                                : 'textSecondary', children: _jsx("strong", { children: step.label }) }), verticalCompleted[index] && (_jsx(Typography, { variant: "body2", color: "primary", display: "inline", style: { marginLeft: '10px' }, children: "Edit" }))] })) : (step.label) }), _jsxs(StepContent, { children: [step.content, useForwardNav && !!step.forwardNavLabel && (_jsx(Button, { ...step.forwardNavProps, onClick: () => forwardNavClickHandler(index, step.valid()), children: step.forwardNavLabel }))] })] }, step.step));
                }) }) }));
});
export default CustomStepper;
